import { Component, Input } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { OrganizationDetail, Permission } from '../data/organization-detail';
import { AdministratorRole } from '../data/administrator-role';

@Component({
  selector: 'app-org-admins-list',
  templateUrl: './org-admins-list.component.html',
  styleUrls: ['./org-admins-list.component.css']
})
export class OrgAdminsListComponent extends BaseComponent {

  @Input() org: OrganizationDetail;
  @Input() acctID: number;
  @Input() permissions: Permission[];
  adminRoles: AdministratorRole[];

  ngOnInit(): void {
    if (!this.accountCanEditRoles()) return;
    this.dataService.getAdministratorRoles().subscribe(
      roles => {
        this.adminRoles = roles;
      });
  }

  deleteAdmin(event, admin): void {
    event.stopPropagation();
    this.dataService.promptDelete(`This will permanently remove ${admin.AccountName} as an administrator.`)
      .then(() => {
        const newOrg = { ...this.org, Administrators: [...this.org.Administrators] };
        newOrg.Administrators = this.org.Administrators.filter(e => {
          return e.AccountID !== admin.AccountID
        });
        this.deleteObj = admin;
        this.dataService.updateOrganization(newOrg).subscribe(result => {
          this.deleteObj = null;
          this.org.Administrators = newOrg.Administrators;
        });
      });
  }

  updateAdmin(event, admin): void {
    if (!this.accountCanEditRoles()) return;
    const newOrg = { ...this.org };
    var newAdmin = newOrg.Administrators.filter(e => { return e.AccountID === admin.AccountID })[0];
    var newRole = this.adminRoles.filter(e => { return e.Description === event.target.value })[0];
    newAdmin.RoleCode = newRole.Code;
    newAdmin.RoleDescription = newRole.Description;
    this.dataService.updateOrganization(newOrg).subscribe(result => {
      this.org.Administrators = newOrg.Administrators;
    });
  }

  accountCanEditRoles(): boolean {
    return this.permissions && this.permissions.some(p => p.PermissionCode === 'WriteAccounts');
  }
}
